import Create from "./Create";
import Update from "./Update";
import { useSearchParams } from "react-router-dom";

const AntiPhishingCode = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  return (
    <>
      {type === "create" && <Create />}
      {type === "update" && <Update />}
    </>
  );
};

export default AntiPhishingCode;
